import React, { useState } from "react";
import CommonTextInput from "../../components/common/commonTextInput/CommonTextInput";
import CustomToast from "../../toastify/CustomToast";
import { useLocation, useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import i18n from "../../i18n/i18n";
import { useDispatch } from "react-redux";
import {
  checkEmailOrMobileIsExistOrNotAction,
  signUpAction,
} from "../../redux/actions/AuthActions";
import { allRoutes } from "../../routes/routes";
import { auth, RecaptchaVerifier } from "../../module/firebase"; // 🔥 Firebase
import { signInWithPhoneNumber } from "firebase/auth";

const ConfirmMobile = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const previousData = location?.state;
  const [screenData] = useState(previousData?.data);
  const navigate = useNavigate();

  const [expandForm, setExpandForm] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [OTP, setOTP] = useState("");
  const [selCountryCode, setSelCountryCode] = useState("91");
  const [selCountryExpectedLength, setSelCountryExpectedLength] = useState(0);
  const [confirmationResult, setConfirmationResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const setupRecaptcha = () => {
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(auth, "recaptcha-container", {
        size: "invisible",
        callback: () => {},
        "expired-callback": () => {},
      });
      window.recaptchaVerifier.render(); // Important!
    }
  
    return window.recaptchaVerifier;
  };

  const onSignup = () => {

    if (mobileNumber?.trim()?.length === 0) {
      CustomToast.error(i18n.t("enter_mobile_number"));
    } else if (selCountryExpectedLength < mobileNumber?.length) {
      CustomToast.error(i18n.t("enter_valid_mobile"));
    } else {
      setLoading(true);
      setupRecaptcha();
      const appVerifier =  setupRecaptcha();
      const fullPhoneNumber = "+" + mobileNumber;

      signInWithPhoneNumber(auth, fullPhoneNumber, appVerifier)
        .then((result) => {
          setConfirmationResult(result);
          setExpandForm(true);
          CustomToast.success("OTP sent successfully!");
        })
        .catch((error) => {
          console.error("SMS not sent", error);
          CustomToast.error("Failed to send OTP.");
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const onOTPVerify = () => {
    if (OTP?.trim()?.length === 0) {
      return CustomToast.error(i18n.t("please_enter_otp"));
    }

    if (!confirmationResult) {
      return CustomToast.error("OTP session expired. Please try again.");
    }

    setLoading(true);
    confirmationResult
      .confirm(OTP)
      .then(() => {
        // After verifying OTP, check email then sign up
        dispatch(checkEmailOrMobileIsExistOrNotAction("email", screenData?.email?.toLowerCase()))
          .then((res) => {
            if (res?.status) {
              CustomToast.error(res?.message);
              setLoading(false);
            } else {
              const regex = new RegExp(`^\\+${selCountryCode}`);
              const mobile = "+" + mobileNumber;
              const updatedMobile = mobile.replace(regex, "");

              const data = {
                first_name: screenData?.first_name.trim() || "",
                middle_name: screenData?.middle_name.trim() || "",
                last_name: screenData?.last_name.trim() || "",
                email: screenData?.email?.toLowerCase() || "",
                dob: screenData?.dob || "",
                password: screenData?.password || "",
                c_password: screenData?.c_password || "",
                address: screenData?.address || "",
                gender: screenData?.gender || "",
                residence_address: screenData?.residence_address || "",
                mobile: updatedMobile,
                image: "",
                country_code: `+${selCountryCode}` ?? "",
                country: screenData?.country,
                nationality: screenData?.nationality,
                device_token: "xyz",
              };

              dispatch(signUpAction(data))
                .then((response) => {
                  if (response?.status) {
                    navigate(allRoutes.dashboard);
                  }
                })
                .catch((e) => {
                  CustomToast.error(e?.message);
                })
                .finally(() => {
                  setLoading(false);
                });
            }
          })
          .catch(() => {
            CustomToast.error(i18n.t("something_went_wrong"));
            setLoading(false);
          });
      })
      .catch((err) => {
        console.error("OTP Verification Failed", err);
        CustomToast.error(i18n.t("invalid_otp"));
        setLoading(false);
      });
  };

  React.useEffect(() => {
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(auth, "recaptcha-container", {
        size: "invisible",
        callback: () => {},
        "expired-callback": () => {},
      });
      window.recaptchaVerifier.render();
    }
  }, []);
  
  return (
    <>
      <div id="recaptcha-container"></div> {/* 🔥 Required for Firebase */}
      <div className="d-flex flex-column flex-root app-root">
        <div className="main-body-cls">
          <section className="login-page">
            <div className="container custom-container">
              <div className="row justify-content-center mt-5">
                <div className="col-lg-4 col-md-6 col-sm-6">
                  <div className="card border-0">
                    <div className="card-title text-start border-bottom-0">
                      <h2 className="p-3">
                        {expandForm
                          ? i18n.t("otp_verification")
                          : i18n.t("confirm_mobile")}
                      </h2>
                    </div>
                    <div className="card-body">
                      {!expandForm && (
                        <div className="mb-5 position-relative">
                          <PhoneInput
                            country={""}
                            inputStyle={{ width: 380, height: 40 }}
                            value={mobileNumber}
                            onChange={(inputPhone, countryData) => {
                              setMobileNumber(inputPhone);
                              setSelCountryExpectedLength(
                                countryData?.format?.replace(/[()\s+\-]/g, "")?.length
                              );
                              setSelCountryCode(countryData?.dialCode);
                            }}
                            countryCodeEditable={false}
                            enableSearch={true}
                          />
                        </div>
                      )}
                      {expandForm && (
                        <div className="mb-1 position-relative">
                          <label htmlFor="otp" className="form-label flt-label">
                            OTP
                          </label>
                          <CommonTextInput
                            name="otp"
                            value={OTP}
                            className="form-control pe-5"
                            id="otp"
                            maxLength={6}
                            placeholder="Enter OTP"
                            onChange={({ target }) => setOTP(target?.value)}
                          />
                        </div>
                      )}
                      <div style={{ marginTop: 20 }} className="md-4 text-center">
                        <button
                          type="submit"
                          disabled={loading}
                          onClick={expandForm ? onOTPVerify : onSignup}
                          className="btn btn-info button-drk-info"
                        >
                          {loading
                            ? "Please wait..."
                            : expandForm
                            ? "Verify"
                            : "Send"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default ConfirmMobile;
